import React from 'react';
import Header from '../components/header';
import { 
  Button,
  Dialog,
  Paper,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow } from '@mui/material';
import { IStore } from '../models/store';
import { useState, useEffect } from 'react';
import store, { useAppDispatch, useAppSelector } from '../store';
import { getStores } from '../utilities/api-utils';
import { setActiveStore } from '../store/reducers/storeSlice';
import { setIsSearching } from '../store/reducers/cabinetSlice';
import StoreDialog from '../components/dialogs/store-dialog';

function StoresView() {
  const dispatch = useAppDispatch();

  const [stores, setStores] = useState<IStore[]>([]);
  const [dialog, setDialog] = useState<boolean>(false);
  const { activeOrganization } = useAppSelector(store => store.organization);
  const { activeStore } = useAppSelector(store => store.store);

  useEffect(() => {
    dispatch(setIsSearching(false));
  });
  
  const getAllStores = async () => {
    const stores = await getStores((store.getState().authorization.cloudKey));
    const filteredStores = stores.data.filter(x => x.organization_id === activeOrganization);
    // await the sort operation to avoid errors when setting active store on an empty `sorted` object
    const sorted = await filteredStores.sort((a, b) => {
      const textA = a.name.toUpperCase();
      const textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    setStores(sorted);
    dispatch(setActiveStore(sorted[0].id));
  };

  useEffect(() => {
    getAllStores();
  }, [activeOrganization]);
  
  const storeSelected = (storeId: string) => {
    dispatch(setActiveStore(storeId));
    setDialog(true);
  };

  const refresh = async() => {
    getAllStores();
  };

  return (
    <div>
      <Header title='Stores' />
      <Dialog
        sx={{
          width: '100%'
        }}
        fullWidth
        maxWidth='lg'
        open={dialog}
        onClose={() => setDialog(false)}>
        <StoreDialog editingStore={activeStore} setDialog={setDialog} refresh={refresh} />
      </Dialog>
      <Button
        variant='contained'
        sx={{
          width: '175px',
          fontSize: '24px',
          marginTop: '15px',
          marginBottom: '15px'
        }}
        onClick={() => storeSelected('')}>
        New Store
      </Button>
      <TableContainer component={Paper} sx={{maxHeight: '600px'}}>
        <Table
          sx={{minWidth: '600px'}}>
          <TableHead>
            <TableRow>
              <TableCell align='left'>Name</TableCell>
              <TableCell align='center'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stores.map((store, index) => (
              <TableRow key={index}>
                <TableCell>
                  {store.name}
                </TableCell>
                <TableCell align='center' sx={{padding: '0'}}>
                  <Button
                    variant='contained'
                    onClick={() => storeSelected(store.id)}>
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default StoresView;
